const TOUR_STORAGE_KEY = 'psv4_tour_completed'

function getData() {
    try {
        return JSON.parse(localStorage.getItem(TOUR_STORAGE_KEY)) || {}
    } catch {
        return {}
    }
}

export function isTourCompleted(userId, tourKey) {
    const data = getData()
    return data?.[userId]?.[tourKey] === true
}

export function markTourCompleted(userId, tourKey) {
    const data = getData()
    if (!data[userId]) data[userId] = {}
    data[userId][tourKey] = true
    localStorage.setItem(TOUR_STORAGE_KEY, JSON.stringify(data))
}

export function resetTourForUser(userId, tourKey) {
    const data = getData()
    if (data?.[userId]?.[tourKey]) {
        delete data[userId][tourKey]
        localStorage.setItem(TOUR_STORAGE_KEY, JSON.stringify(data))
    }
}
